<script>

  import {API_EMPLOYEE} from '../../common/api'
  import EmployeeCommon from './EmployeeCommon'

  export default {
    name: 'EmployeeAdd',
    extends: EmployeeCommon,
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true
            let params = this.employeeForm
            this.$http.POST(API_EMPLOYEE, params,
              res => {
                this.loading = false;
                this.$emit('addEmployeeSuccess')
              }, err => {
                this.loading = false;
                this.$message.error(err.msg)
              })
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    components: {
      EmployeeCommon
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/employee/EmployeeAdd.vue